
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "b89cba9f-6e12-4382-924a-de38509a4cd6"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/builds/sites/wnhub-general-client/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
